//import logo from './logo.svg';
//import './App.css';

import React from 'react';
import Header from './components/Header';
import Form from './components/Form';
import Footer from './components/Footer';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const App = () => {
  return (
    <ThemeProvider theme={darkTheme}>
    <div>
      <Header />
      <Form />
      <Footer />
    </div>
    </ThemeProvider>
  );
};

export default App;

